export const ACCENT = '#7028DA';
export const ACCENT_LIGHT = 'rgba(112, 40, 218, 0.08)';
export const ACCENT_BORDER = 'rgba(112, 40, 218, 0.35)';

export const panelArrowSx = {
  display: { xs: 'none', md: 'flex' },
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: 32,
  color: ACCENT,
  fontSize: 22,
  fontWeight: 700,
};
